/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsAndConditionsImport } from './routes/terms-and-conditions'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as MyAccountImport } from './routes/my-account'
import { Route as LogoutImport } from './routes/logout'
import { Route as DisclaimerImport } from './routes/disclaimer'
import { Route as ContactUsImport } from './routes/contact-us'
import { Route as BasketImport } from './routes/basket'
import { Route as AccountImport } from './routes/account'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as SystemsIndexImport } from './routes/systems/index'
import { Route as AccountSavedQuotesImport } from './routes/account/saved-quotes'
import { Route as AccountOrdersImport } from './routes/account/orders'
import { Route as AccountHomeImport } from './routes/account/home'
import { Route as AccountDetailsImport } from './routes/account/details'
import { Route as SystemsSystemIdConfiguratorImport } from './routes/systems/$systemId/configurator'
import { Route as SystemsRangesRangeIdIndexImport } from './routes/systems/ranges/$rangeId/index'
import { Route as SystemsGroupSystemGroupIdIndexImport } from './routes/systems/group/$systemGroupId/index'

// Create/Update Routes

const TermsAndConditionsRoute = TermsAndConditionsImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const MyAccountRoute = MyAccountImport.update({
  id: '/my-account',
  path: '/my-account',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const DisclaimerRoute = DisclaimerImport.update({
  id: '/disclaimer',
  path: '/disclaimer',
  getParentRoute: () => rootRoute,
} as any)

const ContactUsRoute = ContactUsImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRoute,
} as any)

const BasketRoute = BasketImport.update({
  id: '/basket',
  path: '/basket',
  getParentRoute: () => rootRoute,
} as any)

const AccountRoute = AccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SystemsIndexRoute = SystemsIndexImport.update({
  id: '/systems/',
  path: '/systems/',
  getParentRoute: () => rootRoute,
} as any)

const AccountSavedQuotesRoute = AccountSavedQuotesImport.update({
  id: '/saved-quotes',
  path: '/saved-quotes',
  getParentRoute: () => AccountRoute,
} as any)

const AccountOrdersRoute = AccountOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AccountRoute,
} as any)

const AccountHomeRoute = AccountHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AccountRoute,
} as any)

const AccountDetailsRoute = AccountDetailsImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => AccountRoute,
} as any)

const SystemsSystemIdConfiguratorRoute =
  SystemsSystemIdConfiguratorImport.update({
    id: '/systems/$systemId/configurator',
    path: '/systems/$systemId/configurator',
    getParentRoute: () => rootRoute,
  } as any)

const SystemsRangesRangeIdIndexRoute = SystemsRangesRangeIdIndexImport.update({
  id: '/systems/ranges/$rangeId/',
  path: '/systems/ranges/$rangeId/',
  getParentRoute: () => rootRoute,
} as any)

const SystemsGroupSystemGroupIdIndexRoute =
  SystemsGroupSystemGroupIdIndexImport.update({
    id: '/systems/group/$systemGroupId/',
    path: '/systems/group/$systemGroupId/',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountImport
      parentRoute: typeof rootRoute
    }
    '/basket': {
      id: '/basket'
      path: '/basket'
      fullPath: '/basket'
      preLoaderRoute: typeof BasketImport
      parentRoute: typeof rootRoute
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsImport
      parentRoute: typeof rootRoute
    }
    '/disclaimer': {
      id: '/disclaimer'
      path: '/disclaimer'
      fullPath: '/disclaimer'
      preLoaderRoute: typeof DisclaimerImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/my-account': {
      id: '/my-account'
      path: '/my-account'
      fullPath: '/my-account'
      preLoaderRoute: typeof MyAccountImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsImport
      parentRoute: typeof rootRoute
    }
    '/account/details': {
      id: '/account/details'
      path: '/details'
      fullPath: '/account/details'
      preLoaderRoute: typeof AccountDetailsImport
      parentRoute: typeof AccountImport
    }
    '/account/home': {
      id: '/account/home'
      path: '/home'
      fullPath: '/account/home'
      preLoaderRoute: typeof AccountHomeImport
      parentRoute: typeof AccountImport
    }
    '/account/orders': {
      id: '/account/orders'
      path: '/orders'
      fullPath: '/account/orders'
      preLoaderRoute: typeof AccountOrdersImport
      parentRoute: typeof AccountImport
    }
    '/account/saved-quotes': {
      id: '/account/saved-quotes'
      path: '/saved-quotes'
      fullPath: '/account/saved-quotes'
      preLoaderRoute: typeof AccountSavedQuotesImport
      parentRoute: typeof AccountImport
    }
    '/systems/': {
      id: '/systems/'
      path: '/systems'
      fullPath: '/systems'
      preLoaderRoute: typeof SystemsIndexImport
      parentRoute: typeof rootRoute
    }
    '/systems/$systemId/configurator': {
      id: '/systems/$systemId/configurator'
      path: '/systems/$systemId/configurator'
      fullPath: '/systems/$systemId/configurator'
      preLoaderRoute: typeof SystemsSystemIdConfiguratorImport
      parentRoute: typeof rootRoute
    }
    '/systems/group/$systemGroupId/': {
      id: '/systems/group/$systemGroupId/'
      path: '/systems/group/$systemGroupId'
      fullPath: '/systems/group/$systemGroupId'
      preLoaderRoute: typeof SystemsGroupSystemGroupIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/systems/ranges/$rangeId/': {
      id: '/systems/ranges/$rangeId/'
      path: '/systems/ranges/$rangeId'
      fullPath: '/systems/ranges/$rangeId'
      preLoaderRoute: typeof SystemsRangesRangeIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AccountRouteChildren {
  AccountDetailsRoute: typeof AccountDetailsRoute
  AccountHomeRoute: typeof AccountHomeRoute
  AccountOrdersRoute: typeof AccountOrdersRoute
  AccountSavedQuotesRoute: typeof AccountSavedQuotesRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountDetailsRoute: AccountDetailsRoute,
  AccountHomeRoute: AccountHomeRoute,
  AccountOrdersRoute: AccountOrdersRoute,
  AccountSavedQuotesRoute: AccountSavedQuotesRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/basket': typeof BasketRoute
  '/contact-us': typeof ContactUsRoute
  '/disclaimer': typeof DisclaimerRoute
  '/logout': typeof LogoutRoute
  '/my-account': typeof MyAccountRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/home': typeof AccountHomeRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/saved-quotes': typeof AccountSavedQuotesRoute
  '/systems': typeof SystemsIndexRoute
  '/systems/$systemId/configurator': typeof SystemsSystemIdConfiguratorRoute
  '/systems/group/$systemGroupId': typeof SystemsGroupSystemGroupIdIndexRoute
  '/systems/ranges/$rangeId': typeof SystemsRangesRangeIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/basket': typeof BasketRoute
  '/contact-us': typeof ContactUsRoute
  '/disclaimer': typeof DisclaimerRoute
  '/logout': typeof LogoutRoute
  '/my-account': typeof MyAccountRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/home': typeof AccountHomeRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/saved-quotes': typeof AccountSavedQuotesRoute
  '/systems': typeof SystemsIndexRoute
  '/systems/$systemId/configurator': typeof SystemsSystemIdConfiguratorRoute
  '/systems/group/$systemGroupId': typeof SystemsGroupSystemGroupIdIndexRoute
  '/systems/ranges/$rangeId': typeof SystemsRangesRangeIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/basket': typeof BasketRoute
  '/contact-us': typeof ContactUsRoute
  '/disclaimer': typeof DisclaimerRoute
  '/logout': typeof LogoutRoute
  '/my-account': typeof MyAccountRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/home': typeof AccountHomeRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/saved-quotes': typeof AccountSavedQuotesRoute
  '/systems/': typeof SystemsIndexRoute
  '/systems/$systemId/configurator': typeof SystemsSystemIdConfiguratorRoute
  '/systems/group/$systemGroupId/': typeof SystemsGroupSystemGroupIdIndexRoute
  '/systems/ranges/$rangeId/': typeof SystemsRangesRangeIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/basket'
    | '/contact-us'
    | '/disclaimer'
    | '/logout'
    | '/my-account'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-and-conditions'
    | '/account/details'
    | '/account/home'
    | '/account/orders'
    | '/account/saved-quotes'
    | '/systems'
    | '/systems/$systemId/configurator'
    | '/systems/group/$systemGroupId'
    | '/systems/ranges/$rangeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account'
    | '/basket'
    | '/contact-us'
    | '/disclaimer'
    | '/logout'
    | '/my-account'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-and-conditions'
    | '/account/details'
    | '/account/home'
    | '/account/orders'
    | '/account/saved-quotes'
    | '/systems'
    | '/systems/$systemId/configurator'
    | '/systems/group/$systemGroupId'
    | '/systems/ranges/$rangeId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/basket'
    | '/contact-us'
    | '/disclaimer'
    | '/logout'
    | '/my-account'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-and-conditions'
    | '/account/details'
    | '/account/home'
    | '/account/orders'
    | '/account/saved-quotes'
    | '/systems/'
    | '/systems/$systemId/configurator'
    | '/systems/group/$systemGroupId/'
    | '/systems/ranges/$rangeId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRouteWithChildren
  BasketRoute: typeof BasketRoute
  ContactUsRoute: typeof ContactUsRoute
  DisclaimerRoute: typeof DisclaimerRoute
  LogoutRoute: typeof LogoutRoute
  MyAccountRoute: typeof MyAccountRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SignUpRoute: typeof SignUpRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  SystemsIndexRoute: typeof SystemsIndexRoute
  SystemsSystemIdConfiguratorRoute: typeof SystemsSystemIdConfiguratorRoute
  SystemsGroupSystemGroupIdIndexRoute: typeof SystemsGroupSystemGroupIdIndexRoute
  SystemsRangesRangeIdIndexRoute: typeof SystemsRangesRangeIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRouteWithChildren,
  BasketRoute: BasketRoute,
  ContactUsRoute: ContactUsRoute,
  DisclaimerRoute: DisclaimerRoute,
  LogoutRoute: LogoutRoute,
  MyAccountRoute: MyAccountRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SignUpRoute: SignUpRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  SystemsIndexRoute: SystemsIndexRoute,
  SystemsSystemIdConfiguratorRoute: SystemsSystemIdConfiguratorRoute,
  SystemsGroupSystemGroupIdIndexRoute: SystemsGroupSystemGroupIdIndexRoute,
  SystemsRangesRangeIdIndexRoute: SystemsRangesRangeIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/account",
        "/basket",
        "/contact-us",
        "/disclaimer",
        "/logout",
        "/my-account",
        "/privacy-policy",
        "/sign-up",
        "/terms-and-conditions",
        "/systems/",
        "/systems/$systemId/configurator",
        "/systems/group/$systemGroupId/",
        "/systems/ranges/$rangeId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/account": {
      "filePath": "account.tsx",
      "children": [
        "/account/details",
        "/account/home",
        "/account/orders",
        "/account/saved-quotes"
      ]
    },
    "/basket": {
      "filePath": "basket.tsx"
    },
    "/contact-us": {
      "filePath": "contact-us.tsx"
    },
    "/disclaimer": {
      "filePath": "disclaimer.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/my-account": {
      "filePath": "my-account.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/terms-and-conditions": {
      "filePath": "terms-and-conditions.tsx"
    },
    "/account/details": {
      "filePath": "account/details.tsx",
      "parent": "/account"
    },
    "/account/home": {
      "filePath": "account/home.tsx",
      "parent": "/account"
    },
    "/account/orders": {
      "filePath": "account/orders.tsx",
      "parent": "/account"
    },
    "/account/saved-quotes": {
      "filePath": "account/saved-quotes.tsx",
      "parent": "/account"
    },
    "/systems/": {
      "filePath": "systems/index.tsx"
    },
    "/systems/$systemId/configurator": {
      "filePath": "systems/$systemId/configurator.tsx"
    },
    "/systems/group/$systemGroupId/": {
      "filePath": "systems/group/$systemGroupId/index.tsx"
    },
    "/systems/ranges/$rangeId/": {
      "filePath": "systems/ranges/$rangeId/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
